module.exports = __webpack_public_path__ + "media/images/web/home/index/and_more-17f1b04ad88a169edf75f2bc341fa7b1.jpg";